import React from "react";
import { useAuthorization } from "../../contexts/AuthorizationContext";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ groups = [], children }) => {
  const { selectedGroup } = useAuthorization();

  return groups.some((g) => g.value === selectedGroup) ? (
    children
  ) : (
    <Navigate to="/" replace />
  );
};

export default ProtectedRoute;
